import React from "react";
import { Boxes } from "lucide-react";

/**
 * Stock-level chip used inside forms, queue cards, and the inventory page.
 * Variants:
 *  - red    : Current_Stock <= Low_Stock_Threshold
 *  - yellow : Current_Stock <= Reorder_Point
 *  - green  : healthy
 */
export default function StockBadge({ item, level, size = "sm", testid, label }) {
  const lv = level || item?.stock_level;
  if (!lv) return null;
  const colors = {
    red: "bg-rose-100 text-rose-800 border-rose-700",
    yellow: "bg-amber-100 text-amber-800 border-amber-700",
    green: "bg-emerald-100 text-emerald-800 border-emerald-700",
  };
  const text =
    label ??
    (item ? `${item.Item_Name} · ${item.Current_Stock}` : lv.toUpperCase());
  const sizing = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      data-testid={testid || `stock-${lv}`}
      data-stock-level={lv}
      className={`inline-flex items-center gap-1 font-bold uppercase tracking-wide rounded-sm border-2 ${colors[lv] || colors.green} ${sizing}`}
    >
      <Boxes strokeWidth={2.5} className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} />
      {text}
    </span>
  );
}
